var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "pb-2 sm:pb-4 md:pb-6 px-7 flex flex-col bg-white projBlock",
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-row justify-between pt-6 items-center pb-4" },
        [
          _c("CardBodyItem", {
            attrs: {
              label: "Active Clients",
              labelClass: "mainLabel",
              additionalClass: "customHeading",
              totalNumber: _vm.activeProjects.length,
            },
          }),
          _c("AddContractorToProject", {
            staticClass: "flex justify-end",
            attrs: {
              buttonSize: "xl",
              currentUser: _vm.currentUser,
              companyId: _vm.companyId,
              contractorId: _vm.contractorId,
            },
            on: { activityAdded: _vm.refetchCollection },
          }),
        ],
        1
      ),
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.projects, loading: _vm.$apollo.loading } },
        [
          _vm.activeProjects.length === 0
            ? _c("div", { staticClass: "mb-10" }, [
                _c(
                  "span",
                  { staticClass: "font-normal text-base text-gray-new -mt-1" },
                  [_vm._v(" You do not have any Active Clients ")]
                ),
              ])
            : [
                _c("ElementsSizeProvider", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ setSize, getBlockMinHeight }) {
                        return [
                          _c(
                            "CardsContainer",
                            _vm._l(
                              _vm.activeProjects,
                              function (project, index) {
                                return _c("ProjectCard", {
                                  key: project.id,
                                  attrs: {
                                    project: project,
                                    companyId: _vm.companyId,
                                    currentUser: _vm.currentUser,
                                    hideManager: _vm.hideManager,
                                    descriptionBlockHeight: getBlockMinHeight({
                                      id: project.id,
                                      blockName: "description",
                                      index,
                                    }),
                                  },
                                  on: {
                                    "update:descriptionBlockHeight": (
                                      minHeight
                                    ) =>
                                      setSize({
                                        id: project.id,
                                        blockName: "description",
                                        minHeight,
                                        index,
                                      }),
                                    projectUpdated: function ($event) {
                                      return _vm.$emit("projectUpdated")
                                    },
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
        ],
        2
      ),
      _c("CardBodyItem", {
        staticClass: "mb-1",
        attrs: {
          label: "Completed Clients",
          additionalClass: "customHeading",
          totalNumber: _vm.completedProjects.length,
        },
      }),
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.projects, loading: _vm.$apollo.loading } },
        [
          _vm.completedProjects.length === 0
            ? _c("div", { staticClass: "mb-10" }, [
                _c(
                  "span",
                  { staticClass: "font-normal text-base text-gray-new -mt-1" },
                  [_vm._v(" You do not have any Closed Client profiles ")]
                ),
              ])
            : [
                _c("ElementsSizeProvider", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ setSize, getBlockMinHeight }) {
                        return [
                          _c(
                            "CardsContainer",
                            _vm._l(
                              _vm.completedProjects,
                              function (project, index) {
                                return _c("ProjectCard", {
                                  key: project.id,
                                  attrs: {
                                    project: project,
                                    companyId: _vm.companyId,
                                    currentUser: _vm.currentUser,
                                    hideManager: _vm.hideManager,
                                    descriptionBlockHeight: getBlockMinHeight({
                                      id: project.id,
                                      blockName: "description",
                                      index,
                                    }),
                                  },
                                  on: {
                                    "update:descriptionBlockHeight": (
                                      minHeight
                                    ) =>
                                      setSize({
                                        id: project.id,
                                        blockName: "description",
                                        minHeight,
                                        index,
                                      }),
                                    projectUpdated: function ($event) {
                                      return _vm.$emit("projectUpdated")
                                    },
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
        ],
        2
      ),
      _c("CardBodyItem", {
        staticClass: "mb-1",
        attrs: {
          label: "Draft Clients",
          additionalClass: "customHeading",
          totalNumber: _vm.draftProjects.length,
        },
      }),
      _c(
        "LoadingOverlay",
        { attrs: { hasData: !!_vm.projects, loading: _vm.$apollo.loading } },
        [
          _vm.draftProjects.length === 0
            ? _c(
                "span",
                {
                  staticClass: "font-normal text-base text-gray-new mb-1 -mt-1",
                },
                [_vm._v(" You do not have any Draft Client profiles ")]
              )
            : [
                _c("ElementsSizeProvider", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ setSize, getBlockMinHeight }) {
                        return [
                          _c(
                            "CardsContainer",
                            _vm._l(
                              _vm.draftProjects,
                              function (project, index) {
                                return _c("ProjectCard", {
                                  key: project.id,
                                  attrs: {
                                    project: project,
                                    companyId: _vm.companyId,
                                    currentUser: _vm.currentUser,
                                    hideManager: _vm.hideManager,
                                    descriptionBlockHeight: getBlockMinHeight({
                                      id: project.id,
                                      blockName: "description",
                                      index,
                                    }),
                                  },
                                  on: {
                                    "update:descriptionBlockHeight": (
                                      minHeight
                                    ) =>
                                      setSize({
                                        id: project.id,
                                        blockName: "description",
                                        minHeight,
                                        index,
                                      }),
                                    projectUpdated: function ($event) {
                                      return _vm.$emit("projectUpdated")
                                    },
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }